<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/myfavoritethings">私のお気に入り</router-link></li>
        </ul>
      </div>
    </div>
    <div class="myfavoritethings">
      <div class="container">
        <div class="container-child">
          <div class="myfavoritethings__title">
            <h2>MY FAVORITE THINGS<span>私のお気に入り</span></h2>
            <p>HARUMI FLAGの魅力を発見！<br>住民のみなさんから<wbr>投稿いただいた写真を<wbr>掲載しています。</p>
            <a class="btn_link" @click="anchorLoginLink()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 22">
                <path d="M16,9.28c-2.15,0-3.88,1.55-3.88,3.46s1.74,3.46,3.88,3.46,3.88-1.55,3.88-3.46-1.74-3.46-3.88-3.46Z"/>
                <path d="M29.92,4.36h-3.66c-.82,0-1.56-.43-1.89-1.09l-1.1-2.17c-.33-.66-1.08-1.09-1.89-1.09h-10.75c-.82,0-1.56.43-1.9,1.09l-1.1,2.17c-.34.66-1.08,1.09-1.89,1.09h-3.66c-1.15,0-2.08.83-2.08,1.85v13.94c0,1.02.93,1.85,2.08,1.85h27.85c1.15,0,2.08-.83,2.08-1.85V6.21c0-1.02-.93-1.85-2.08-1.85ZM16,19.66c-4.29,0-7.76-3.1-7.76-6.92s3.47-6.92,7.76-6.92,7.76,3.1,7.76,6.92-3.47,6.92-7.76,6.92Z"/>
              </svg>
              <span>投稿はこちら</span>
            </a>
          </div>
          <div class="myfavoritethings-category">
            <div class="myfavoritethings-category_intro_text">
               <h3>みんなの投稿をチェック</h3>
            </div>
            <div class="skeleton-parent" v-if="isLoading">
              <div v-for="(n, index) in 3" :key="index" class="skeleton-child">
                <PuSkeleton :count="3"/>
              </div>
            </div>
            <div 
              v-for="(item, index) in photo_theme"
              :key="index">
                <div class="myfavoritethings-category__title">
                  <p>{{  item.theme_name }}</p>
                </div>
                <div
                  v-if="item.list.length == 0"
                  class="myfavoritethings-category__empty">
                <p>現在ご案内する情報はありません</p>
                </div>
                <div 
                  v-else
                  class="myfavoritethings-category__list">
                  <div 
                    v-for="(photo, photoindex) in item.list"
                    :key="photoindex"
                    class="myfavoritethings-category__list__item"
                  >
                    <div 
                      data-fancybox
                      :data-src="'#pop' + photo.post_id" 
                      class="item__holder itemstatus__new"
                      :class="{itemstatus__new: diffDate(photo.created_at) <= 7}"
                    >
                      <div 
                        class="itemstatus__new__banner"
                        v-if="diffDate(photo.created_at) <= 7"
                      >
                        <img src="@/assets/img/top/portal_icon.svg" alt="" />
                        <div class="itemstatus__new__banner__text">
                          NEW
                        </div>
                      </div>
                      <div class="item__img" >
                        <img v-if="photo.photo_image != null" :src="$func.formatUrl(photo.photo_image)" :alt="photo.comment">
                      </div>
                      <div class="item__text">
                        <div class="item__name">{{photo.nick_name}}</div>
                        <div class="item__info">
                          <div class="item__date">{{ formatDate(photo.created_at) }}</div>
                          <div class="item__no"><span>No. </span>{{photo.post_id}}</div>
                        </div>
                      </div>
                    </div>
                    <div 
                      :id="'pop' + photo.post_id" 
                      class="popup_holder"
                      >
                      <div class="popupdetail">
                        <div class="popupdetail__img">
                          <img v-if="photo.photo_image != null" :src="$func.formatUrl(photo.photo_image)" :alt="photo.comment">
                        </div>
                        <div class="popupdetail__text">
                          <div class="item__category">
                            <button 
                              v-if="photo.theme_name != null && photo.theme_name != ''"
                              class="item__category__btn"
                              data-fancybox-close 
                              @click="categoryLink(photo.theme_id)">
                              {{ photo.theme_name }}
                            </button>
                          </div>
                          <div class="item__title">{{photo.nick_name}}</div>
                          <div class="item__info">
                            <div class="item__date">{{ formatDate(photo.created_at) }}</div>
                            <div class="item__no"><span>No. </span>{{photo.post_id}}</div>
                          </div>
                          <div class="item__content">{{ photo.comment }}</div>
                          <div class="item__btn">
                            <button data-fancybox-close class="close_btn">
                              <svg viewBox="0 0 11.14 11.14">
                                <rect class="cls-1" x="-1.43" y="4.69" width="14" height="1.75" transform="translate(5.57 13.44) rotate(-135)"/>
                                <rect class="cls-1" x="-1.43" y="4.69" width="14" height="1.75" transform="translate(-2.31 5.57) rotate(-45)"/>
                              </svg>
                              <span>閉じる</span>
                            </button>
                          </div>
                        </div>
                        <div 
                          class="itemstatus__new__banner"
                          v-if="diffDate(photo.created_at) <= 7"
                        >
                          <img src="@/assets/img/top/portal_icon.svg" alt="" />
                          <div class="itemstatus__new__banner__text">
                            NEW
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="item.list.length > 0" class="myfavoritethings-category__btn">
                  <router-link 
                    class="btn_link"
                    :to="'/myfavoritethings/'+ item.theme_id"
                  >
                    もっと見る
                  </router-link>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="loginForm" class="myfavoritethings__form">
      <div class="container">
        <div class="container-child">
          <div class="myfavoritethings__form__holder">
            <div class="myfavoritethings__form__title">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 22">
                <path d="M16,9.28c-2.15,0-3.88,1.55-3.88,3.46s1.74,3.46,3.88,3.46,3.88-1.55,3.88-3.46-1.74-3.46-3.88-3.46Z"/>
                <path d="M29.92,4.36h-3.66c-.82,0-1.56-.43-1.89-1.09l-1.1-2.17c-.33-.66-1.08-1.09-1.89-1.09h-10.75c-.82,0-1.56.43-1.9,1.09l-1.1,2.17c-.34.66-1.08,1.09-1.89,1.09h-3.66c-1.15,0-2.08.83-2.08,1.85v13.94c0,1.02.93,1.85,2.08,1.85h27.85c1.15,0,2.08-.83,2.08-1.85V6.21c0-1.02-.93-1.85-2.08-1.85ZM16,19.66c-4.29,0-7.76-3.1-7.76-6.92s3.47-6.92,7.76-6.92,7.76,3.1,7.76,6.92-3.47,6.92-7.76,6.92Z"/>
              </svg>
              <span>投稿はこちら</span>
            </div>
            <div class="myfavoritethings__form__text">投稿は、SEA VILLAGE、SUN VILLAGE、PARK VILLAGE<wbr>にお住まいの方が対象です。<br>マンションポータルサイトに<wbr>ご登録の「ユーザーID」と「パスワード」で<wbr>ログインしてください。</div>
            <div class="myfavoritethings__form__login">
              <form class="form">
                <div class="form__holder">
                  <div class="form__row">
                    <div class="form__title"><label>ユーザーID</label></div>
                    <div class="form__content"><input v-model="loginData.user_id" :disabled="loadingForm" type="text" name="id"/></div>
                  </div>
                  <div class="form__row">
                    <div class="form__title"><label>パスワード</label></div>
                    <div class="form__content"><input v-model="loginData.password" :disabled="loadingForm" type="password" name="password"/></div>
                  </div>
                  <div v-if="errorMessage != ''" class="form__row">
                    <p class="form__error"> {{ errorMessage }} </p>
                  </div>
                </div>
              </form>
              <div class="myfavoritethings__form__button">
                <button v-if="loadingForm" class="btn_link disabled">ログイン</button>
                <button v-else @click="submitLogin" class="btn_link">ログイン</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sliderSite } from "@/assets/js/myfavoritethings";
import { RouterLink } from "vue-router";
import axios from "axios";
import { metaData, getListThemeName, getPhotoList, diffDate, formatDate, formatWeekDay  } from '@/utils/helper';

export default {
  name: "Myfavoritethings",
  components: {
    VueSkeletonLoader: () => {
      VueSkeletonLoader;
    },
  },
  props: ['isScrollToLogin'],
  data() {
    return {
      // informationList: CONSTANT.dataInformationList,
      // list_information: [],
      loginData: {
        user_id: '',
        password: ''
      },
      errorMessage: "",
      loadingForm: false,
      photo_theme: [],
      photo_per_photo_theme: 3,
      isLoading: false,
      checkDataExists: false,
      displayEmpty: false,
    };
  },

  methods: {
    formatDate, 
    formatWeekDay, 
    diffDate,

    anchorLoginLink() {
      var element_to_scroll_to = this.$refs.loginForm;
      element_to_scroll_to.scrollIntoView();
    },
    async submitLogin() {
      this.errorMessage = ""
      this.loadingForm = true
      await axios.post('/api/login', this.loginData).then((response) => {
        const token = response.data?.data?.token || ""
        
        if (token != "") {
          sessionStorage.setItem("token", token)
          this.$router.push('myfavoritethings/form')
        }
      }).catch((error) => {
        this.errorMessage = ""
        let errorList = error?.response?.data?.error || []
        for (const errorResponse of errorList)
        {
          this.errorMessage += (errorResponse?.messageError || "") + "\n"
        }
      })
      this.loadingForm = false
    },
    categoryLink(url) {
      this.$router.push(`/myfavoritethings/${url}`);
    },
    getListThemeName: async function () {
      this.isLoading = true;
      try {
        const listPhotoTheme = await getListThemeName('/photo_theme');
        var parsedobj = JSON.parse(JSON.stringify(listPhotoTheme.data));
        return parsedobj;
      } catch (e) {
          console.log(e)
      }
    },
    getPhotoList: async function () {
      this.isLoading = true;
      try {
        const listPhotoEntry = await getPhotoList('/photo_entry');
        var parsedobj = JSON.parse(JSON.stringify(listPhotoEntry.data));
        return parsedobj;
      } catch (e) {
          console.log(e)
      }
    },
  },
  created() {
    sessionStorage.removeItem('token');
    metaData(
      `MY FAVORITE THINGS | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのMY FAVORITE THINGSのご案内ページです。',
      'HARUMIFLAGタウンポータル',
      'article',
    )
  },
  
  async mounted() {
    await Promise.all([this.getListThemeName(),this.getPhotoList()])
    .then((results) => {
      var theme_in_photo_entry = Object.keys(results[1]);
      results[0].forEach(user => {
        var check_themename = theme_in_photo_entry.includes(user.theme_name);
        if (check_themename == true) {
          user.list = results[1][user.theme_name].slice(0, this.photo_per_photo_theme);
        } else {
          user.list = [];
        }
      });
      this.photo_theme = results[0];
      this.isLoading = false;
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      setTimeout(() => {
        if (this.$props.isScrollToLogin) {
          this.anchorLoginLink();
        }
      }, 100);
    });
    
    
  },
  updated() {
    sliderSite();
  }
};
</script>
